// extracted by mini-css-extract-plugin
export default {"back-btn-label":"DSM_back-btn-label__fKS7F","btn-back-envirtual-container":"DSM_btn-back-envirtual-container__AlF+M","ddl":"DSM_ddl__i5sKP"};